<app-modal-wrapper ariaRole="dialog" ariaLabelledBy="invoice-modal-title" [ariaDescribedBy]="undefined" [title]="invoiceNumber() ? 'INVOICE ' + invoiceNumber() : 'INVOICE'">
  <div class="modal-body">
    @if (dataLoading()) {
      <app-loading-animation></app-loading-animation>
    }
    @if (dataAvailable()) {
      <div class="modal-body__content invoice-table">
        <table aria-describedby="title" aria-label="Invoice Details">
          <thead>
            <tr>
              <th scope="col" tabindex="0">Description</th>
              <th scope="col" class="number" tabindex="0">Amount ({{invoiceCurrency()}})</th>
            </tr>
          </thead>
          <tbody>
            @for (invoice of invoiceLines(); track invoice) {
              <tr class="table-data-row">
                <td class="table-data-cell" tabindex="0">{{invoice.Description}}</td>
                <td class="table-data-cell number" tabindex="0">{{invoice.Amount}}</td>
              </tr>
            }
            <tr class="table-data-row invoice-total-row">
              <td class="table-data-cell invoice-total-label" tabindex="0">Total:</td>
              <td class="table-data-cell number" tabindex="0">{{invoiceTotal()}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    }
  </div>
</app-modal-wrapper>
